import { IAnchorTag } from 'types/anchor'
import { useEffect, useRef, useState, MouseEvent } from 'react'
import Link from '@components/common/NoPrefetchLink'
import { stringToHash } from '@utils/contentful/stringToHash'
import { scrollToElementSmoothly } from '@utils/utilities'

interface IProductPageSubmenu {
  submenuItems: IAnchorTag[]
  hashFromScrollPosition: string
}
const LINK_SCREEN_SIDE_OFFSET = 24

export default function ProductPageSubmenu({
  submenuItems,
  hashFromScrollPosition,
}: IProductPageSubmenu) {
  const linksRef = useRef([])
  const submenuWrapper = useRef(null)
  const [activeHash, setActiveHash] = useState(hashFromScrollPosition)

  useEffect(() => {
    const submenuElement = submenuWrapper.current
    const linkElementIndex = submenuItems.findIndex(
      (item) => item.hash === activeHash
    )
    const linkElement = linksRef.current[linkElementIndex]
    const linkBounds = linkElement?.getBoundingClientRect()

    if (linkBounds?.left < LINK_SCREEN_SIDE_OFFSET) {
      submenuElement.scrollTo({
        top: 0,
        left: linkElement.offsetLeft - LINK_SCREEN_SIDE_OFFSET,
        behavior: 'smooth',
      })
    }

    if (linkBounds?.right > submenuElement.offsetWidth) {
      submenuElement.scrollTo({
        top: 0,
        left:
          linkElement.offsetLeft -
          linkElement.offsetWidth -
          LINK_SCREEN_SIDE_OFFSET,
        behavior: 'smooth',
      })
    }
  }, [activeHash])

  function handleClick(e: MouseEvent, label: string) {
    e.preventDefault()
    const hash = stringToHash(label)
    const element = document.getElementById(hash)
    setActiveHash(hash)
    scrollToElementSmoothly(element, { offset: 100 })
  }

  return (
    <div
      ref={submenuWrapper}
      className="relative flex items-center h-[44px] bg-white w-full overflow-x-auto px-[20px] md:px-0 justify-start md:justify-center no-scrollbar border-y-core-grey-20 border-y"
    >
      {submenuItems.map((item, index) => (
        <div
          ref={(el) => {
            linksRef.current[index] = el
            return linksRef.current[index]
          }}
          key={item.hash}
          className={`mx-4 text-lg leading-6 h-full py-[1px] hover:pb-0 hover:border-b-[1px] hover:border-pitaya transition-font duration-150 overflow-visible ${
            activeHash === item.hash
              ? 'text-pitaya font-bold border-b-[1px] border-pitaya pb-0'
              : 'text-core-grey-80'
          }`}
        >
          <Link href={'#' + item.hash}>
            <a
              onClick={(e) => handleClick(e, item.label)}
              className="flex items-center h-full select-none whitespace-nowrap"
            >
              {item.label}
            </a>
          </Link>
        </div>
      ))}
    </div>
  )
}
